import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/assetTransferReport'
import Component from 'components/Reports/AssetTransferReport'

export default createListViewContainer({ actions, selectors: selectors.assetTransferReport })(Component)
